import { FC } from "react";

import {
  JunkLoadType,
  PhotoWithCommentType,
  ServicesType,
} from "@/domain/models/job";

import { NotesIcon } from "../blocks";
import { ImgSliderFromPaths } from "../components/ImgsSliderFromPaths";
import { useServiceQuery } from "../data/queries/serviceQueries";

type DriverTaskPicturePropsType = {
  jobId: string;
  serviceId: string;
  field: keyof ServicesType | keyof JunkLoadType;
  junkLoadIndex?: number | null;
};

const Photo = (photo: PhotoWithCommentType) => {
  const photoComment = photo.comment;
  const hasComment = Boolean(photoComment);

  return (
    <div className="relative">
      <ImgSliderFromPaths
        className="h-12 w-12 object-cover"
        paths={[photo.photoUrl]}
      />

      {hasComment && (
        <div className="absolute bottom-0 right-0">
          <NotesIcon
            className="rounded-b-none rounded-tr-none h-6 w-8 items-center justify-center flex"
            iconClassName="mx-0 my-0"
          />
        </div>
      )}
    </div>
  );
};

const DriverTaskPicture: FC<DriverTaskPicturePropsType> = ({
  jobId,
  serviceId,
  field,
  junkLoadIndex,
}) => {
  const { data: serviceData } = useServiceQuery({ jobId, serviceId });

  const photoField =
    junkLoadIndex !== undefined && junkLoadIndex !== null
      ? serviceData?.junkLoads?.[junkLoadIndex]?.[field as keyof JunkLoadType]
      : serviceData?.[field as keyof ServicesType];

  if (!photoField) {
    return null;
  }

  const uploadedPhoto = (photoField ?? "") as
    | PhotoWithCommentType
    | PhotoWithCommentType[];

  if (Array.isArray(uploadedPhoto)) {
    return (
      <div className="flex space-x-2">
        {uploadedPhoto.map((photo, index) => (
          <Photo key={index} {...photo} />
        ))}
      </div>
    );
  }

  return (
    <div className="flex">
      <Photo {...uploadedPhoto} />
    </div>
  );
};

export { DriverTaskPicture };
